import { StarterKitEnvironment } from '@costco-service-catalog/bff-types';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Box, Button, Chip } from '@mui/material';
import { Dispatch, SetStateAction, useState } from 'react';

interface EnvironmentSortProps {
  selected: StarterKitEnvironment;
  data: StarterKitEnvironment[];
  setPosition: Dispatch<SetStateAction<number>>;
}

const EnvironmentSort = (props: EnvironmentSortProps) => {
  const { data, setPosition, selected } = props;
  const [envList, setEnvList] = useState(data);

  const getIndex = (item: StarterKitEnvironment) =>
    envList.findIndex((element: StarterKitEnvironment) => element === item);

  const moveItem = (
    item: StarterKitEnvironment,
    fromIndex: number,
    toIndex: number
  ) => {
    const newList = envList.slice();
    newList.splice(fromIndex, 1);
    newList.splice(toIndex, 0, item);
    setEnvList(newList);
    setPosition(toIndex);
  };

  const handleMoveUp = () => {
    const fromIndex = getIndex(selected);
    const toIndex = fromIndex > 0 ? fromIndex - 1 : 0;
    moveItem(selected, fromIndex, toIndex);
  };

  const handleMoveDown = () => {
    const lastIndex = envList.length - 1;
    const fromIndex = getIndex(selected);
    const toIndex = fromIndex === lastIndex ? lastIndex : fromIndex + 1;
    moveItem(selected, fromIndex, toIndex);
  };

  return (
    <div>
      <Box sx={{ display: 'flex' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            paddingTop: '1.5rem',
            paddingRight: '2rem',
          }}
        >
          <Button
            variant="contained"
            type="button"
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
            }}
            onClick={handleMoveUp}
          >
            <ArrowUpwardIcon sx={{ marginRight: '1rem' }} /> Move Up
          </Button>
          <Box sx={{ padding: '.75rem' }} />
          <Button variant="contained" type="button" onClick={handleMoveDown}>
            <ArrowDownwardIcon sx={{ marginRight: '1rem' }} /> Move Down
          </Button>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            paddingTop: '1rem',
          }}
        >
          {envList.map((env: StarterKitEnvironment) => (
            <Box
              key={`${env.type}${env.name}`}
              sx={{
                display: 'flex',
                alignItems: 'center',
                padding: '.5rem 0',
                borderBottom: '1px solid rgba(0,0,0,0.0)',
              }}
            >
              {env === selected && (
                <>
                  <Chip
                    label={getIndex(env) + 1}
                    color="primary"
                    sx={{ marginRight: '1rem' }}
                  />
                  <Box sx={{ fontWeight: 'bold' }}>
                    [{env.type}] {env.name}
                  </Box>
                </>
              )}
              {env !== selected && (
                <>
                  <Chip
                    label={getIndex(env) + 1}
                    sx={{ marginRight: '1rem' }}
                  />
                  <Box>
                    [{env.type}] {env.name}
                  </Box>
                </>
              )}
            </Box>
          ))}
        </Box>
      </Box>
    </div>
  );
};

export default EnvironmentSort;
